// src/pages/UserPage.js - 用户中心
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Row, Col } from 'antd';
import { ThunderboltOutlined, UserOutlined } from '@ant-design/icons';
import { api } from '../services/api';

const cardStyle = {
  background: 'linear-gradient(135deg, #0d1f44 0%, #132c5e 100%)',
  border: '1px solid rgba(0, 180, 216, 0.3)',
  borderRadius: 8,
  boxShadow: '0 0 20px rgba(0, 180, 216, 0.1)',
};
const COLORS = { primary: '#00d4ff', text: '#fff', muted: 'rgba(255,255,255,0.6)' };

const UserPage = () => {
  const { t } = useTranslation();
  const [user, setUser] = useState({ name: t('user.title') });
  const [stats, setStats] = useState({ todayPower: 0, totalPower: 0, online: 0 });

  useEffect(() => {
    const saved = localStorage.getItem('currentUser');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setUser(parsed);
      } catch (e) {}
    }
    api.getDeviceStats().then(json => {
      if (json.success) setStats({
        todayPower: parseFloat(json.stats.todayPower || 0),
        totalPower: parseFloat(json.stats.totalPower || 0),
        online: json.stats.status?.[t('collection.running')] || 0,
      });
    });
  }, []);

  return (
    <div style={{ minHeight: '100%' }}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card variant="borderless" style={cardStyle} styles={{ body: { padding: 32 } }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
              <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'linear-gradient(135deg, rgba(0,180,216,0.3), rgba(0,180,216,0.1))', border: '2px solid rgba(0,180,216,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <UserOutlined style={{ fontSize: 32, color: COLORS.primary }} />
              </div>
              <div>
                <div style={{ fontSize: 24, fontWeight: 700, color: COLORS.text, marginBottom: 4 }}>{user.name}</div>
                <div style={{ fontSize: 13, color: COLORS.muted }}>{t('user.normalUser')} | {user.email || t('user.emailNotSet')}</div>
                <div style={{ fontSize: 12, color: COLORS.muted, marginTop: 4 }}>{t('user.phone')}: {user.phone || t('user.phoneNotSet')}</div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        {[
          { label: t('user.todayGeneration'), value: stats.todayPower.toFixed(1), unit: 'kWh', color: COLORS.primary },
          { label: t('user.totalGeneration'), value: stats.totalPower.toFixed(1), unit: 'kWh', color: '#f4c542' },
          { label: t('user.onlineDevice'), value: stats.online, unit: t('user.unit'), color: '#52e8b0' },
        ].map(item => (
          <Col xs={24} sm={8} key={item.label}>
            <Card variant="borderless" style={cardStyle} styles={{ body: { padding: '24px' } }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <div style={{ width: 48, height: 48, borderRadius: 10, background: 'rgba(0,180,216,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(0,180,216,0.3)' }}>
                  <ThunderboltOutlined style={{ fontSize: 22, color: item.color }} />
                </div>
                <div>
                  <div style={{ fontSize: 12, color: COLORS.muted }}>{item.label}</div>
                  <div style={{ fontSize: 26, fontWeight: 700, color: item.color }}>{item.value} <span style={{ fontSize: 12, color: COLORS.muted }}>{item.unit}</span></div>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default UserPage;
